// extracted by mini-css-extract-plugin
export default {"container":"smallbox_container__ovf0Y","iconWrapper":"smallbox_iconWrapper__mpYzQ","text":"smallbox_text__WaEyd"};